import { useEffect, useState } from 'react'
import { Container, Row, Col, Modal, Button, Card } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useAuth } from '../../components/auth/useAuth'
import { getAnimals, addAnimal, editAnimal } from '../../actions/other/animalsActions'
import { getLots, getForSelect } from '../../actions/other/lotsActions'
import { CustomDataTable } from '../../components/design/Datatables/CustomDataTable'
import Swal from 'sweetalert2'
import Loader from '../../components/loaders/Loader'
import AnimalForm from '../../components/forms/AnimalForm'

export default function Animals() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const {clientauth} = useAuth()

    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(25)
    const [search, setSearch] = useState('')
    const [searchAux, setSearchAux] = useState('')
    const [totalRows, setTotalRows] = useState(0)

    const {animal, animals, resultanimal, loading, total} = useSelector(state=>state.animals)
    const {lotsForSelect} = useSelector(state=>state.lots)

    const [modalShow, setModalShow] = useState(false)
    const [formState, setFormState] = useState({})
    const [isRegistering, setIsRegistering] = useState(false)
    const [isAddingOrEditing, setIsAddingOrEditing] = useState(false)

    useEffect(() => {
        if(clientauth){
            dispatch(getAnimals(page, limit, search))
            dispatch(getForSelect())
        }
    },[dispatch, t, clientauth])

    useEffect(() => {
        if (clientauth) {
            dispatch(getAnimals(page, limit, search))
        }
    }, [page, limit, search])

    useEffect(() => {
        setTotalRows(total || 0)
    }, [total])

    const openModal = () =>{
        setIsAddingOrEditing('adding')
        setFormState({})
        setModalShow(true)
    }

    const selectAnimal = (animal) => {
        setFormState({...animal})
        setIsAddingOrEditing('editing')
        setModalShow(true)
    }

    const handleInputChange = ({target})=>{
        if(target.name === 'province'){
            setFormState({
                ...formState,
                'province': target.value,
                'town': ''
            })
        }else{
            setFormState({
                ...formState,
                [target.name]: target.value
            })
        }
    }

    const handleSubmit= async(e) => {
        e.preventDefault()
        setIsRegistering(true)

        if(isAddingOrEditing==='editing'){
            dispatch(editAnimal(formState, formState._id))
        }else{
            dispatch(addAnimal(formState))
        }
        setIsRegistering(false)
    }

    useEffect(() => {
        if(resultanimal){
            let resultanimalnow = resultanimal
            dispatch({ type: 'ANIMAL_RESET_RESULT' })
            switch (resultanimalnow) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.animal.addsuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                case 'needMoreData':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.ok'),
                        icon: 'warning',
                        text: t('admin.animal.needMoreData')
                    })
                    break;
                case 'editSuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.animal.editSuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultanimal])

    const columnsAnimal = [
        {
            name: t('admin.animal.identifier'),
            cell: animal =>
                <div className='cursor' onClick={() => selectAnimal(animal)}>
                    {animal.identifier || '—'}
                </div>,
            selector: (animal) => animal.identifier || '—',
            sortable: true,
        },
        {
            name: t('admin.animal.crotal'),
            cell: animal =>
                <div className='cursor' onClick={() => selectAnimal(animal)}>
                    {animal.crotal || '—'}
                </div>,
            selector: (animal) => animal.crotal || '—',
            sortable: true,
        },
        {
            name: t('admin.animal.breed'),
            cell: animal =>
                <div className='cursor' onClick={() => selectAnimal(animal)}>
                    {typeof animal.breed === 'string'
                        ? animal.breed  // Offline: solo ID de raza
                        : t(`admin.animal.breed_${animal.breed?.name}`) || '—'}
                </div>,
            selector: animal => typeof animal.breed === 'string'
                ? animal.breed
                : animal.breed?.name || '—',
            sortable: true,
        },
        {
            name: t('admin.animal.lot'),
            cell: animal =>
                <div className='cursor' onClick={() => selectAnimal(animal)}>
                    {animal.lot?.identifier || animal.lot || '—'}
                </div>,
            selector: (animal) => animal.lot?.identifier || animal.lot || '—',
            sortable: true,
        },
        {
            name: '',
            width: '100px',
            cell: animal =>
                <div className='cursor' onClick={() => selectAnimal(animal)}>
                    <i className='fas fa-pencil'></i>
                </div>,
            sortable: false,
        }
    ]

    return (
        <Container className='p-5'>
            <Row>
                <Col xs={12}>
                    <h1>{t('admin.animal.animals')}</h1>
                </Col>
                <Col xs={12} className='d-flex justify-content-end'>
                    <Button variant='primary' type="submit" className="my-2 cursor" onClick={() => openModal()}>
                        <i className="fas fa-plus me-2"></i>  {t('admin.animal.createanimal')}
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col xs={12} className='my-3'>
                    {loading ?
                        <Loader/>
                    :
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body>
                                        <div className="d-flex my-2">
                                            <input
                                                type="text"
                                                className="form-control me-2"
                                                placeholder={t("datatables.buscar")}
                                                value={searchAux || ""}
                                                onChange={e => {
                                                    setSearchAux(e.target.value);
                                                    setPage(1);
                                                }}
                                                onKeyDown={(e) => {if (e.key === 'Enter') { setSearch(searchAux); setPage(1); }}}
                                            />
                                            <Button onClick={() => setSearch(searchAux)}><i className='fas fa-search'></i></Button>
                                        </div>
                                        {animals?.length > 0 ?
                                            <CustomDataTable
                                                columns={columnsAnimal}
                                                data={animals}
                                                pagination
                                                paginationServer
                                                paginationTotalRows={totalRows}
                                                searchText={search}
                                                onChangeRowsPerPage={(newLimit, page) => {
                                                    if (limit !== newLimit) {
                                                        setLimit(newLimit)
                                                        setPage(1)
                                                    }
                                                }}
                                                onChangePage={(newPage) => {
                                                    setPage(newPage)
                                                }}
                                            />
                                        :
                                            <h4 className='mt-4'>{t('admin.animal.thereisnotanimal')}</h4>
                                        }
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    }
                </Col>
            </Row>
            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                aria-labelledby="contained-modal-title-vcenter"
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <h2>{t('admin.animal.animal')}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AnimalForm
                        state={formState}
                        animaltype={'admin'}
                        handleInputChange={handleInputChange}
                        submit={handleSubmit}
                        isAddingOrEditing={isAddingOrEditing}
                        isRegistering={isRegistering}
                        lotOptions={lotsForSelect}
                    />
                </Modal.Body>
            </Modal>
        </Container>
    )
}